<template>
  <div class="full-height layout column">
    <header-view>
      <template v-slot:left>
        <v-tabs left>
          <v-tab
            v-for="(item, index) in tabs"
            :key="index"
            :to="`/resources/${item.id}`"
            :disabled="item.disabled"
          >
            {{ item.name }}
          </v-tab>
        </v-tabs>
      </template>
      <template v-slot:actions>
        <core-input
          :prepend-icon="icons.search"
          class="mr-4"
          label="Search References"
          @keydown="e => (search = e)"
          :onInput="true"
        />

        <core-button
          label="Add Reference"
          :icon="icons.add"
          @click.stop="$router.push({ query: { ...$route.query, dialog: 1, form: 'add_reference' } })"
        />
      </template>
    </header-view>
    <!-- <v-toolbar dense flat style="background-color: white;" tabs>

      
    </v-toolbar>-->
    <v-divider />
    <i-rack>
      <i-section>
        <v-slide-x-transition>
          <div v-if="tab === 'docs'">
            <documents-table :highlighted="highlighted" @selected="getSelectedDocs" />
          </div>
          <div v-else-if="tab === 'cfes'">
            <cfes-table :highlighted="highlighted" @selected="getSelectedCfes" />
          </div>
          <div v-else>
            <reference :search-prop="search" :highlighted="highlighted" />
          </div>
        </v-slide-x-transition>
      </i-section>
    </i-rack>
  </div>
</template>

<script>
// base
// components
import DocumentsTable from '@/components/resources/documents';
import CfesTable from '@/components/resources/cfes';
import Reference from '@/components/resources/references';
import HeaderViewVue from '../../components/core/header/HeaderView.vue';
import CoreInputVue from '../../components/core/inputs/CoreInput.vue';
import CoreButtonVue from '../../components/core/buttons/CoreButton.vue';
import icons from '../../mixins/icons';
import BaseDialogVue from '../../components/core/views/dialogs/BaseDialog.vue';
// services
// import {ExportService} from '@/services/modules/export'
// constants

export default {
  components: {
    DocumentsTable,
    CfesTable,
    Reference,
    headerView: HeaderViewVue,
    coreInput: CoreInputVue,
    coreButton: CoreButtonVue,
    coreDialog: BaseDialogVue
  },
  mixins: [icons],
  data() {
    return {
      search: null,
      highlighted: this.$router.currentRoute.query.id || null,
      tab: this.$router.currentRoute.params.site,
      tabs: [
        {
          id: 'refs',
          name: 'References'
        },
        {
          id: 'docs',
          name: 'Documents',
          disabled: true
        },
        {
          id: 'cfes',
          name: 'CFEs',
          disabled: true
        }
      ]
    };
  },
  computed: {},
  watch: {
    '$route.params.site': {
      handler: function(o) {
        this.tab = o;
      }
    }
  },
  methods: {
    getSelectedDocs(selected) {},
    getSelectedCfes(selected) {}
  }
};
</script>

<style lang="scss"></style>
